export const sortYearOptions = (yearOptions: any): any => {
  return yearOptions.sort((a: any, b: any) => (a.value > b.value ? -1 : 1));
};
